import { createContext, useContext } from 'react';
import type { LandingType } from '#website/helpers.tsx';

export interface LandingState {
	columnWidth: number;
	menuOpened: boolean;
	toggleMenu: () => void;
	closeMenu: () => void;
	isFloatingHeaderPinnedDisabled: boolean;
	setIsFloatingHeaderPinnedDisabled: (pinned: boolean) => void;
	headerPinned: boolean;
	landingSource: LandingType;
	isMedical?: boolean;
	isVet?: boolean;
}

export const LandingContext = createContext<LandingState | undefined>(undefined);

export const useLanding = (): LandingState => {
	const context = useContext(LandingContext);
	if (!context) {
		throw new Error('useLanding must be used within a LandingProvider');
	}
	return context;
};
